import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './TechIssues.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export const TechIssues = () => {
  const { t } = useTranslation();

  return (
    <S.Section>
      <S.Header>
        <S.Title $variant="2">{t('pages.cabinet.my_cards')}</S.Title>
      </S.Header>

      <S.Box>
        <IconBox
          $filename="tech-issues.png"
          $width={75}
          $height={75}
          $iconWidth={75}
          $iconHeight={75}
        />
        <S.Text $variant="1">
          {t('pages.cabinet.cards_list_tech_issues')}
        </S.Text>
      </S.Box>
    </S.Section>
  );
};
